// Vendor
import { ref } from 'vue';
import { defineStore } from 'pinia';
import { DynamicURL } from '@netvlies/utility-collection';
// Globals
import { API_PREFIX } from '../../endpoints';
// Stores
import { useContextStore } from '../../../context';
const useSyliusShopTaxonItem = defineStore('shopTaxonItem', () => {
    // Composable
    const { $api, $endpoints } = useContextStore();
    // Refs
    const item = ref({
        data: null,
        loaded: false,
    });
    // Methods
    async function fetchByCode(options) {
        const { code, updateState = true } = options;
        if (updateState) {
            item.value.data = null;
            item.value.loaded = false;
        }
        const url = new DynamicURL(`${API_PREFIX.SHOP}${$endpoints.TAXON_BY_CODE}`).setRouteParams(`${code}`);
        const response = await $api
            .get(url.resolve())
            .catch((error) => Promise.reject(error));
        const { data } = response;
        if (data) {
            if (updateState) {
                item.value.data = data;
                item.value.loaded = false;
            }
            return data;
        }
        return null;
    }
    return {
        fetchByCode,
        item,
    };
});
export { useSyliusShopTaxonItem };
//# sourceMappingURL=item.js.map